import React from 'react';
import { Form, Upload, Button, Icon, notification } from '@block/plug';
import Url from '../url';
import { doAction } from '../../../utils';

const { helper } = Upload;

// 简历

interface Props {
  attachment: any;
  count?: number;
  onUpload: (e: any) => void;
}
interface State {
  loading: boolean;
  fileList: any[];
}
class Resume extends React.Component<Props, State> {
  uploadRef: any;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      fileList: [],
    };
  }

  componentDidMount() {
    const { attachment } = this.props;
    if (attachment) {
      this.setState({ fileList: attachment });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { attachment } = nextProps;
    const { attachment: propsAttachment } = this.props;
    if (attachment !== propsAttachment) {
      this.setState({ fileList: attachment });
    }
  }

  validateFileType = (file, accepted) => {
    const fileExt = (/^.*\.(.*)$/.exec(file.name) || ['', ''])[1].toLowerCase();
    const valid = accepted.includes(fileExt);
    if (!valid) {
      notification.error({
        message: `支持上传 ${accepted.join('、')}格式文件`,
      });
    }
    return valid;
  };

  validateFileSize = (file, size) => {
    const valid = file.size / 1024 <= size * 1024;
    if (!valid) {
      notification.error({
        message: `文件大小超过${size}M,请重新上传`,
      });
    }
    return valid;
  };

  // 上传模板
  handleUpload = (file) => {
    this.setState({ loading: true });
    const type = ['png', 'jpeg', 'jpg', 'pdf', 'doc', 'docx'];
    // !this.validateFileType(file, ['ppt', 'pptx', 'doc', 'docx', 'pdf']) ||
    if (!this.validateFileType(file, type) || !this.validateFileSize(file, 20)) {
      this.setState({ loading: false });
      return false;
    }

    helper.upload(Url.upload, file, {
      params: {},
      onSuccess: (res) => {
        let { count } = this.props;
        count = count || 4; // 最多4个
        let { fileList } = this.state;
        fileList = fileList || [];
        if (fileList.length >= count) {
          fileList = fileList.splice(0, fileList.length - 1);
        }
        fileList.push(res);
        this.setState({
          loading: false,
          fileList,
        });
        const { onUpload } = this.props;
        onUpload && onUpload(fileList);
        notification.success({
          message: '上传成功',
        });
      },
      onError: (err) => {
        this.setState({ loading: false });
        notification.error({
          message: err.message || '上传失败',
        });
      },
    });

    return true;
  };

  handleDownload = (fileId, fileName) => {
    // const { fileId, fileName } = this.state;
    const tenantUid = window.location.hash.split('/')[2];
    window.open(`/api/candidate/entry/${tenantUid}/attachment/view/${fileId}/${fileName}/do`);
  };

  handleRemove = async (fileId) => {
    await doAction(Url.delete, { fileId }, null);
    notification.success({
      message: '删除成功',
    });
    const { fileList } = this.state;
    const list = fileList.filter((item) => item.fileId !== fileId);
    this.setState({ fileList: list });
    const { onUpload } = this.props;
    onUpload?.(list);
  };

  render() {
    const { fileList, loading } = this.state;
    return (
      <>
        <div className="base-form__title">
          简历附件
          <span className="base-form__desc">（主要用于核对工作相关内容）</span>
        </div>
        <Form ref={this.uploadRef} labelWidth="120px">
          <Form.Item label="简历附件：" required message="不能为空">
            {(!fileList || (fileList && fileList.length < 4)) && (
              <Upload multiple={false} onUpload={this.handleUpload}>
                <Button loading={loading} icon={loading ? '' : 'export-o'}>
                  简历附件
                </Button>
              </Upload>
            )}
            {fileList &&
              fileList.map((item) => {
                const { fileName } = item;
                return (
                  <div className="resume__file">
                    <span className="resume__wrapper">
                      <Icon type="file-o" />
                      <span className="resume__filename">{fileName}</span>
                    </span>
                    <span>
                      <Icon type="download-o" onClick={() => this.handleDownload(item.fileId, item.fileName)} />
                      <Icon type="delete-o" onClick={() => this.handleRemove(item.fileId)} />
                    </span>
                  </div>
                );
              })}
          </Form.Item>
        </Form>
      </>
    );
  }
}

export default Resume;
